// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product__callouts-item-icon .image__img {
  height: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/product.bundle/styles/product-callouts.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF","sourcesContent":[".product__callouts-item-icon .image__img {\n  height: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
